import { WHATSAPP_TEMPLATE_VARIABLE_SAMPLES } from '@/lib/constants/whatsapp-templates';

/** Replaces `{{variable_name}}` placeholders with sample values for preview. */
export function previewTemplateBody(body: string): string {
  return renderTemplateWithVariables(body, {});
}

/** Replaces `{{variable_name}}` placeholders with provided values (falls back to samples). */
export function renderTemplateWithVariables(
  body: string,
  variables: Record<string, string>
): string {
  return body.replace(/\{\{(\w+)\}\}/g, (_, name: string) => {
    const value = variables[name]?.trim();
    if (value) return value;
    return WHATSAPP_TEMPLATE_VARIABLE_SAMPLES[name] ?? `[${name}]`;
  });
}

/** Lists unique named placeholders found in template text. */
export function extractTemplateVariables(
  ...parts: Array<string | null | undefined>
): string[] {
  const found = new Set<string>();
  const pattern = /\{\{(\w+)\}\}/g;

  for (const part of parts) {
    if (!part) continue;
    let match: RegExpExecArray | null;
    while ((match = pattern.exec(part)) !== null) {
      found.add(match[1]);
    }
  }

  return Array.from(found);
}
